import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d8bf0e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = ["innerHTML"];
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    effect: {
      type: String,
      default: 'dark'
    },
    content: {
      type: String,
      default: '提示内容'
    },
    placement: {
      type: String,
      default: 'top'
    },
    size: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#FEC171'
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_i_ep_info_filled = _resolveComponent("i-ep-info-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createBlock(_component_el_tooltip, {
        effect: __props.effect,
        placement: __props.placement
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", {
          innerHTML: __props.content
        }, null, 8, _hoisted_2)])])]),
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "marginL5 question",
          size: __props.size,
          color: __props.color
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_info_filled)]),
          _: 1
        }, 8, ["size", "color"])]),
        _: 3
      }, 8, ["effect", "placement"]);
    };
  }
});